<template src='./modal.pug' lang='pug'></template>

<script>
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'Modal',

  props: {
    bodyClass: {
      Type: String,
      default: 'modal-body'
    },
    id: {},
    size: {},
    closable: {},
    closeFunction: {}
  },

  methods: {
    trackEvent () {
      trackAnalyticsEvent(this, 'close-modal', 'titlebar-close-modal-click', this.id)
      if (this.closeFunction) {
        this.closeFunction()
      }
    }
  }
}
</script>

<style>
.concil-modal-header {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #fff;
  color: #1b3c65;
  border-bottom: 2px solid #d0d0d0;
  padding: 0 15px;
}

.concil-modal-header h1 {
  font-size: 2em;
  margin-top: 15px;
  margin-bottom: 0px;
}

.concil-modal-header h4 {
  margin-top: 5px;
  margin-left: 2px;
  margin-bottom: 10px;
}

.concil-modal-header button {
  color: #b1b1b1;
  margin: 5px 10px 0px 0px !important;
  font-size: 40px;
  opacity: 1 !important;
}

.concil-modal-header button:hover {
  color: #1b3c65;
}

/*Template*/
.modal-footer {
  padding: 15px !important;
}

.modal-new-attribute {
  width: 850px;
}

.modal-new-attribute.modal-dialog {
  transform: none !important;
}
</style>



// WEBPACK FOOTER //
// Modal.vue?de99bfb0